/** @sfdc-extension-file SNK */
import type { ComponentType } from 'react';
import type { ShopperExperience } from '@/scapi';

export type PreloadFallbackProps = {
    component: ShopperExperience.schemas['Component'];
};

export type PreloadFallbackComponent = ComponentType<PreloadFallbackProps>;

type PreloadFallbackModule = {
    default: PreloadFallbackComponent;
    componentTypeIds: readonly string[];
};

const preloadFallbacks = new Map<string, PreloadFallbackComponent>();

const fallbackModules = import.meta.glob<PreloadFallbackModule>(
    ['/src/components/**/*-preload-fallback.tsx', '/src/features/**/*-preload-fallback.tsx'],
    { eager: true }
);

for (const fallbackModule of Object.values(fallbackModules)) {
    for (const typeId of fallbackModule.componentTypeIds) {
        preloadFallbacks.set(typeId, fallbackModule.default);
    }
}

export function registerPreloadFallback(typeId: string, fallback: PreloadFallbackComponent): void {
    preloadFallbacks.set(typeId, fallback);
}

export function getPreloadFallback(typeId: string): PreloadFallbackComponent | undefined {
    return preloadFallbacks.get(typeId);
}
